import React, { useRef } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import RegionCityList from '../regionCityList';

const CustomToggle = React.forwardRef(({ children, onClick, empty }, ref) => (
  <Button
    ref={ref}
    className={`dropdown-btn${empty ? ' empty' : ''}`}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <span style={{
      flex: 1,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maskImage: 'linear-gradient(to right, #000 calc(100% - 1.5rem), transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, #000 calc(100% - 1.5rem), transparent 100%)',
    }}>
      {children}
    </span>
    <i className="fas fas--arrow fa-chevron-down" />
  </Button>
));

const CityDropdown = ({ onChange, onRegionChange, currentCity, currentRegion, cities, regions, isOpen, onToggle }) => {
  const buttonRef = useRef();

  const label = currentCity
    ? `м. ${currentCity.name}`
    : currentRegion
    ? currentRegion.name
    : '';

  const isEmpty = !currentCity && !currentRegion;

  const handleSelectCity = (city) => {
    if (onChange) onChange(city);
    if (onToggle) onToggle(false);
    if (buttonRef.current) buttonRef.current.blur();
  };

  const handleSelectRegion = (region) => {
    if (onRegionChange) onRegionChange(region);
    if (onToggle) onToggle(false);
    if (buttonRef.current) buttonRef.current.blur();
  };

  return (
    <Dropdown className="city-header-dropdown" show={isOpen} onToggle={onToggle}>
      <Dropdown.Toggle ref={buttonRef} as={CustomToggle} empty={isEmpty}>
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ minWidth: '15rem' }}>
          <RegionCityList
            regions={regions || []}
            cities={cities || []}
            currentRegion={currentRegion}
            currentCity={currentCity}
            onSelectRegion={handleSelectRegion}
            onSelectCity={handleSelectCity}
          />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CityDropdown;
